import { Typography } from '@mui/material'
import { CheckCircleOutline } from '@mui/icons-material'

import AccessGateLayout from './AccessGateLayout'

interface AccessGateApprovedProps {
  entityName: string
  message?: string
}

const AccessGateApproved: React.FC<AccessGateApprovedProps> = ({ entityName, message }) => {
  return (
    <AccessGateLayout>
      <CheckCircleOutline color="success" sx={{ fontSize: 72 }} />

      <Typography variant="h6" fontWeight={700}>
        Acesso liberado
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {message || `Seu acesso a ${entityName} foi liberado. Acessando o carregador...`}
      </Typography>
    </AccessGateLayout>
  )
}

export default AccessGateApproved
